
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface AuthRouteProps {
  redirectTo?: string;
}

export const AuthRoute: React.FC<AuthRouteProps> = ({ redirectTo = '/auth' }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-pulse">
          <div className="h-12 w-12 rounded-full bg-primary flex items-center justify-center mx-auto">
            <span className="text-white font-bold text-xl">SR</span>
          </div>
          <div className="mt-4 text-center">
            <p className="text-lg text-muted-foreground">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};
